import useEmailCheck from 'components/profile/useEmailCheck';
import { resendVerificationToken } from 'lib/api/owner_api';
import { MemberResponse } from 'lib/teams';
import { useRouter } from 'next/router';
import { HTMLProps, useEffect, useRef, useState } from 'react';
import AccountAction from './AccountAction';
import styles from './AccountActions.module.css';

export const CreateTeamButton = () => {
  const label = 'Create new Workspace';
  return <AccountAction label={label} href="/account/create-team" />;
};

export const EditProfileButton = ({ onClick }: HTMLProps<HTMLDivElement>) => {
  return (
    <div className={styles.Button} onClick={onClick}>
      Edit Profile
    </div>
  );
};

export const ChangePasswordButton = () => (
  <AccountAction label="Change Password" href="/account/password" />
);

export const DeleteAccountButton = () => (
  <AccountAction label="Delete Account" href="/account/delete" />
);

interface ViewTeamProps {
  isAdmin: boolean;
  teamId: number;
}

export const ViewTeamButton = ({ isAdmin, teamId }: ViewTeamProps) => (
  <AccountAction
    label={`${isAdmin ? 'Manage' : 'View'} ${'Workspace'}`}
    href={`/account/${teamId}`}
  />
);

export const ViewPlanFeaturesButton = () => (
  <AccountAction label="View Plan Features" href="https://rive.app/pricing" />
);

export const ContactButton = () => (
  <AccountAction
    label="this form"
    href="https://rive.app/enterprise"
    external={true}
  />
);

interface MemberButtonProps {
  teamId: number;
  member: MemberResponse;
}

export const MemberButton = ({ teamId, member }: MemberButtonProps) => (
  <AccountAction
    className={styles.MemberButton}
    label={member.name ?? member.username ?? member.email}
    href={`/account/${teamId}/${member.username}`}
  />
);

export const BackToAccount = () => {
  const router = useRouter();
  return (
    <button
      className={styles.Button}
      onClick={() => router.replace('/account')}
    >
      Back to Account
    </button>
  );
};

export const GoBack = () => {
  const { back } = useRouter();
  return (
    <button className={styles.Button} onClick={back}>
      Go back
    </button>
  );
};

export const ResendEmailVerification = () => {
  const timerRef = useRef<any | null>(null);
  const [resent, setResent] = useState<boolean>(false);
  const emailVerified = useEmailCheck();

  function sendVerification() {
    setResent(true);
    resendVerificationToken();
  }

  useEffect(() => {
    return () => clearTimeout(timerRef.current);
  }, []);

  useEffect(() => {
    timerRef.current = setTimeout(() => setResent(false), 3000);
  }, [resent]);

  if (emailVerified) {
    return <></>;
  }

  return (
    <button
      className={styles.Button}
      onClick={sendVerification}
      disabled={resent}
    >
      {resent ? 'Verification Email Sent' : 'Resend Email Verification'}
    </button>
  );
};
